'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            },
        });
    }
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }
    $('.add-to-wishlist-messages').append(
        '<div class="add-to-wishlist-alert text-center ' +
			status +
			'">' +
			data.msg +
			'</div>'
    );

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 1500);
    var $targetElement = $('a[data-pid="' + data.pid + '"]')
        .closest('.product-info')
        .find('.remove-product');
    var itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid'),
    };
    $('body').trigger('afterRemoveFromCart', itemToMove);
    setTimeout(function () {
        $('.cart.cart-page #removeProductModal').modal();
    }, 2000);
}

/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
    $('body').on('click', '.product-move .move', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var optionId = $(this)
            .closest('.product-info')
            .find('.lineItem-options-values')
            .data('option-id');
        var optionVal = $(this)
            .closest('.product-info')
            .find('.lineItem-options-values')
            .data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal,
            },
            success: function (data) {
                displayMessageAndRemoveFromCart(data);
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            },
        });
    });
}

module.exports = function () {
    cart();

    moveToWishlist();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text('(' + count.quantityTotal + ')');
            $('.minicart .minicart-quantity').attr(
                'data-quantity',
                count.quantityTotal
            );
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems,
            });
        }
    });

    $('.minicart').on('click', function () {
        var url = $('.minicart').data('action-url');
        // var count = parseInt(
        //     $('.minicart .minicart-quantity').data('quantity'),
        //     10
        // );

        // if (count !== 0) {
        $('body').addClass('side-panel-open');
        $('html, body').css('overflow', 'hidden');
        if (!updateMiniCart) {
            $('.js-mini-cart-module').addClass('show-module');
            return;
        }
        $.spinner().start();
        $.get(url, function (data) {
            $('.js-mini-cart-module').replaceWith(data);
            updateMiniCart = false;
            $('.js-mini-cart-module').addClass('show-module');
            $('body').trigger('minicart:loadRecommendation');
            $.spinner().stop();
        });
        // }
    });

    $('body').on('change', '.minicart .quantity', function () {
        var location = Location;

        if (
            $(this).parents('.bonus-product-line-item').length &&
			$('.cart-page').length
        ) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
    // logic to handle the add to cart from minicart in the recommendation section
    $(document).on('click', '.js-recommendation-add-to-cart', function (e) {
        e.preventDefault();
        $.spinner().start();
        var pid = $(this).data('pid');
        var form = {
            pid: pid,
            quantity: 1,
        };
        var addToCartUrl = $(this).attr('href');
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    $('body').trigger('product:afterAddToCart', data);
                    $('.minicart').trigger('click');
                    $.spinner().stop();
                    miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        }
    });
};
